import { UserWebSocket } from "./UserWebSocket"

export function getUserWebSocket() {
	return userWebSocket
}

const userWebSocket = new UserWebSocket()
